export default __webpack_public_path__ + "static/media/managed.e16a643a.svg";